{
  "breadcrumbAriaLabel": "Breadcrumb",
  "homeAriaLabel": "Home",
  "mainNavAriaLabel": "Main navigation",
  "closeSidebarAriaLabel": "Close sidebar",
  "collapse": "Collapse",
  "help": "Help",
  "settings": "Settings",
  "myProfile": "My Profile",
  "groups": {
    "clinical": "Clinical",
    "worklists": "Worklists",
    "documentation": "Documentation",
    "orders": "Orders",
    "medications": "Medications",
    "scheduling": "Scheduling",
    "billing": "Billing",
    "analytics": "Analytics",
    "organization": "Organisation",
    "security": "Security",
    "accessReviews": "Access Reviews",
    "integrations": "Integrations",
    "system": "System",
    "licensing": "Licensing"
  },
  "dashboard": "Dashboard",
  "patients": "Patients",
  "patientSearch": "Patient Search",
  "myPatients": "My Patients",
  "censusBedBoard": "Census / Bed Board",
  "providerDirectory": "Provider Directory",
  "providerCoverage": "Provider Coverage",
  "patientMerge": "Patient Merge",
  "inbox": "Inbox",
  "pendingResults": "Pending Results",
  "criticalResults": "Critical Results",
  "unsignedNotes": "Unsigned Notes",
  "cosignQueue": "Cosign Queue",
  "noteTemplates": "Note Templates",
  "smartPhrases": "Smart Phrases",
  "orderCatalog": "Order Catalogue",
  "orderSets": "Order Sets",
  "encounters": "Encounters",
  "orders": "Orders",
  "results": "Results",
  "medications": "Medications",
  "notes": "Notes",
  "medicationWorklist": "Medication Worklist",
  "formulary": "Formulary",
  "pharmacistQueue": "Pharmacist Queue",
  "appointments": "Appointments",
  "scheduleManagement": "Schedule Management",
  "waitlist": "Waitlist",
  "charges": "Charges",
  "claims": "Claims",
  "payments": "Payments",
  "accounts": "Accounts",
  "statements": "Statements",
  "denials": "Denials",
  "analyticsDashboard": "Dashboard",
  "reports": "Reports",
  "qualityMeasures": "Quality Measures",
  "healthSystems": "Health Systems",
  "facilities": "Facilities",
  "locations": "Locations",
  "clinicalTaxonomy": "Clinical Taxonomy",
  "serviceLocation": "Service ↔ Location",
  "providers": "Providers",
  "users": "Users",
  "roles": "Roles",
  "accessMatrix": "Access Matrix",
  "integrations": "Integrations",
  "thirdPartyApps": "Third-Party Apps",
  "audit": "Audit",
  "system": "System",
  "cdsRules": "CDS Rules",
  "escalationRules": "Escalation Rules",
  "segments": {
    "search": "Search",
    "register": "Register",
    "demographics": "Demographics",
    "census": "Census",
    "discharge": "Discharge",
    "catalog": "Catalogue",
    "sets": "Order Sets",
    "pending": "Pending",
    "critical": "Critical",
    "reconciliation": "Reconciliation",
    "worklist": "Worklist",
    "templates": "Templates",
    "smartPhrases": "Smart Phrases",
    "schedule": "Schedule Management",
    "quality": "Quality Measures",
    "administration": "Administration",
    "auditLog": "Audit Log",
    "allergies": "Allergies",
    "problems": "Problems",
    "immunizations": "Immunisations",
    "insurance": "Insurance"
  },
  "handoffs": "Handoffs",
  "duplicateReview": "Duplicate Review",
  "sso": "SSO & Directories",
  "userGroups": "User Groups",
  "fileKey": "File key",
  "ordersWorklist": "Orders Worklist"
}
